import { router } from './router';

export default function App() {
  return router();
}
